import React, {useState, useContext, useEffect} from 'react'


import { FirebaseContext } from '../../Services/firebase'
import { PDFViewer } from '@react-pdf/renderer';

import { TextField, Button, Autocomplete, Dialog, DialogContent } from '@mui/material';

import PdfChoices from './PdfChoices';

import { getCustomerList } from '../../Utils/getCustomerList';

export default function WeekChoices(props) {

    const firebase = useContext(FirebaseContext)

    const [Customers, setCustomers] = useState([]);
    const [CustomerInfos, setCustomerInfos] = useState([]);
    const [value, setValue] = useState('clients');
    const [inputValue, setInputValue] = React.useState('');
    const [WeekState, setWeekState] = React.useState('');
    const [Exist, setExist] = useState(false);
    const [open, setOpen] = React.useState(false);

    const [daysData, setDaysData] = useState({
        Lundi: [],
        Mardi: [],
        Mercredi: [],
        Jeudi: [],
        Vendredi: [],
        Samedi: [],
        Dimanche: [],
    });

    const getInfos = () => {
        setCustomerInfos([])
        firebase.getCustomerInfos(props.UserSession.uid, value).get()
        .then( doc => {
            const mydata = doc.data()
            setCustomerInfos(mydata)
        })
    }

    useEffect(() => {
        getCustomerList(firebase, props.UserSession.uid, setCustomers)
    }, [firebase, props.UserSession.uid])

    const checkChoices = (event) => {
        setWeekState(event.target.value)
    }

    const getRecap = () => {
        getInfos();
    
        for (let day = 1; day <= 7; day++) {
            firebase.getCustomerChoices(props.UserSession.uid, value, WeekState, String(day)).get()
                .then(querySnapshot => {
                    const dayNames = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];
                    const dayName = dayNames[day - 1];
                    
                    querySnapshot.docs.forEach(result => {
                        setDaysData(prev => ({
                            ...prev,
                            [dayName]: [...prev[dayName], result.data()],
                        }));
                    });
                });
        }
    
        setExist(true);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setValue('semaines');
    
        // Réinitialiser tout l'objet daysData
        setDaysData({
            Lundi: [],
            Mardi: [],
            Mercredi: [],
            Jeudi: [],
            Vendredi: [],
            Samedi: [],
            Dimanche: [],
        });
    };

    return(
        <div style={{display: "flex", flexDirection: "column"}}>
            <Autocomplete
                    value={value}
                    onChange={(event, newValue) => {
                        setValue(newValue);
                    }}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) => {
                        setInputValue(newInputValue);
                    }}
                    disablePortal
                    id="combo-box-demo"
                    options={Customers}
                    sx={{ width: 300 }}
                    renderInput={(params) => <TextField {...params} label="clients"/>}
                />
            <TextField required type="text" name="week" label="numéro de semaine" id="week" value={WeekState} onChange={checkChoices} style={{width: "15vw", marginTop: "2vh"}} />
            <Button onClick={getRecap} style={{marginTop: "2vh", width: "10vh"}} variant="contained">Afficher</Button>
            <div style={{display: "flex", flexDirection: "column", marginLeft: "2vw"}}>
                {
                    Exist === false ? null :
                    <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth={true}
                    maxWidth={'lg'}
                    >
                        <DialogContent>
                            <PDFViewer style={{width: "90vw", height: "80vh"}}>
                                <PdfChoices client={value} client_infos={CustomerInfos} daysData={daysData}/>
                            </PDFViewer>
                        </DialogContent>
                    </Dialog>
                }
            </div>
        </div>
    )
}